import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CKEditorExample } from "../../../../Constant";

const Editor = () => {
  const InnerText: string = "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec at vulputate urna, sed dignissim arcu. Aliquam at ligula imperdiet, faucibus ante a, interdum enim. Sed in mauris a lectus lobortis condimentum. Sed in nunc magna. Quisque massa urna, cursus vitae commodo eget, rhoncus nec erat. Sed sapien turpis, elementum sit amet elit vitae, elementum gravida eros. In ornare tempus nibh ut lobortis. Nam venenatis justo ex, vitae vulputate neque laoreet a.</p>";

  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CKEditorExample} />
        <CardBody>
          <CKEditor editor={ClassicEditor} data={InnerText} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Editor;
